import {
  GET_SHOP_CATEGORY_ICONS_START,
  GET_SHOP_CATEGORY_ICONS_SUCCESS,
  GET_SHOP_CATEGORY_ICONS_ERROR,
  ADD_SHOP_CATEGORY_ICON_START,
  ADD_SHOP_CATEGORY_ICON_SUCCESS,
  ADD_SHOP_CATEGORY_ICON_ERROR,
  EDIT_SHOP_CATEGORY_ICON_START,
  EDIT_SHOP_CATEGORY_ICON_SUCCESS,
  EDIT_SHOP_CATEGORY_ICON_ERROR,
  DELETE_SHOP_CATEGORY_ICON_START,
  DELETE_SHOP_CATEGORY_ICON_SUCCESS,
  DELETE_SHOP_CATEGORY_ICON_ERROR
} from '../../constants';

import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';

const GET_SHOP_CATEGORY_ICONS_QUERY = gql`
query getShopCategoryIcons {
  getShopCategoryIcons {
    results {
      id
      name
      icon
      createdAt
      updatedAt
    }
    status
    errorMessage
  }
}`;

const ADD_SHOP_CATEGORY_ICON_MUTATION = gql`
mutation addShopCategoryIcon($name: String!, $icon: String!) {
  addShopCategoryIcon(name: $name, icon: $icon) {
    status
    errorMessage
    result { id name icon createdAt updatedAt }
  }
}`;

const EDIT_SHOP_CATEGORY_ICON_MUTATION = gql`
mutation editShopCategoryIcon($id: Int!, $name: String, $icon: String) {
  editShopCategoryIcon(id: $id, name: $name, icon: $icon) {
    status
    errorMessage
    result { id name icon createdAt updatedAt }
  }
}`;

const DELETE_SHOP_CATEGORY_ICON_MUTATION = gql`
mutation deleteShopCategoryIcon($id: Int!) {
  deleteShopCategoryIcon(id: $id) {
    status
    errorMessage
  }
}`;

export function getShopCategoryIcons() {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: GET_SHOP_CATEGORY_ICONS_START });
    try {
      const { data } = await client.query({
        query: GET_SHOP_CATEGORY_ICONS_QUERY,
        fetchPolicy: 'network-only'
      });
      if (data && data.getShopCategoryIcons && data.getShopCategoryIcons.status === 200) {
        dispatch({
          type: GET_SHOP_CATEGORY_ICONS_SUCCESS,
          payload: data.getShopCategoryIcons.results
        });
      } else {
        toastr.error('Error', data.getShopCategoryIcons.errorMessage || 'Failed to fetch shop category icons.');
        dispatch({ type: GET_SHOP_CATEGORY_ICONS_ERROR });
      }
    } catch (err) {
      toastr.error('Error', err.message || 'Something went wrong!');
      dispatch({ type: GET_SHOP_CATEGORY_ICONS_ERROR });
    }
  };
}

export function addShopCategoryIcon(values) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: ADD_SHOP_CATEGORY_ICON_START });
    dispatch(setLoaderStart('AddShopCategoryIcon'));
    try {
      const { data } = await client.mutate({
        mutation: ADD_SHOP_CATEGORY_ICON_MUTATION,
        variables: values
      });
      if (data && data.addShopCategoryIcon && data.addShopCategoryIcon.status === 200) {
        toastr.success('Success', 'Shop category icon has been added successfully.');
        dispatch({ type: ADD_SHOP_CATEGORY_ICON_SUCCESS });
      } else {
        toastr.error('Error', data.addShopCategoryIcon.errorMessage || 'Failed to add shop category icon.');
        dispatch({ type: ADD_SHOP_CATEGORY_ICON_ERROR });
      }
    } catch (err) {
      toastr.error('Error', err.message || 'Something went wrong!');
      dispatch({ type: ADD_SHOP_CATEGORY_ICON_ERROR });
    }
    dispatch(setLoaderComplete('AddShopCategoryIcon'));
  };
}

export function editShopCategoryIcon(values) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: EDIT_SHOP_CATEGORY_ICON_START });
    dispatch(setLoaderStart('EditShopCategoryIcon'));
    try {
      const { data } = await client.mutate({
        mutation: EDIT_SHOP_CATEGORY_ICON_MUTATION,
        variables: values
      });
      if (data && data.editShopCategoryIcon && data.editShopCategoryIcon.status === 200) {
        toastr.success('Success', 'Shop category icon has been updated successfully.');
        dispatch({ type: EDIT_SHOP_CATEGORY_ICON_SUCCESS });
      } else {
        toastr.error('Error', data.editShopCategoryIcon.errorMessage || 'Failed to update shop category icon.');
        dispatch({ type: EDIT_SHOP_CATEGORY_ICON_ERROR });
      }
    } catch (err) {
      toastr.error('Error', err.message || 'Something went wrong!');
      dispatch({ type: EDIT_SHOP_CATEGORY_ICON_ERROR });
    }
    dispatch(setLoaderComplete('EditShopCategoryIcon'));
  };
}

export function deleteShopCategoryIcon(id) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: DELETE_SHOP_CATEGORY_ICON_START });
    dispatch(setLoaderStart('DeleteShopCategoryIcon'));
    try {
      const { data } = await client.mutate({
        mutation: DELETE_SHOP_CATEGORY_ICON_MUTATION,
        variables: { id }
      });
      if (data && data.deleteShopCategoryIcon && data.deleteShopCategoryIcon.status === 200) {
        toastr.success('Success', 'Shop category icon has been deleted successfully.');
        dispatch({ type: DELETE_SHOP_CATEGORY_ICON_SUCCESS });
      } else {
        toastr.error('Error', data.deleteShopCategoryIcon.errorMessage || 'Failed to delete shop category icon.');
        dispatch({ type: DELETE_SHOP_CATEGORY_ICON_ERROR });
      }
    } catch (err) {
      toastr.error('Error', err.message || 'Something went wrong!');
      dispatch({ type: DELETE_SHOP_CATEGORY_ICON_ERROR });
    }
    dispatch(setLoaderComplete('DeleteShopCategoryIcon'));
  };
} 